import React from 'react'


const PresaveButton = () => {
  return (
    <div className='absolute left-0 right-0 z-20 text-center' style={{ bottom: '10%' }}>
      <a href="https://orcd.co/fussy" 
        style={{
          color: '#ff7cd6'
        }}
        className={`
          bg-black
          mx-auto
          text-center
          py-4 px-12
          rounded-2xl
          uppercase 
          font-bold
          shadow-lg
          text-xl
          inline-block
        `}>
        Listen Now &rarr;
      </a>
    </div>
  )
}

export default PresaveButton